<template>
  <popup
    :opened="dataToShow > -1"
    @close="changeToShow(-1)"
  >
    <!-- BEGIN Content modal add referent -->
    <div v-if="dataToShow == 1">
      <div class="my-5 mx-5 lg:my-15 lg:mx-40 2xl:my-20 2xl:mx-32">
        <h3 class="mb-10">
          Ajouter un référent
        </h3>

        <div>
          <h6 class="w-full text-center text-indigo-600 mb-10">
            Veuillez saisir les informations du nouveau référent à ajouter
          </h6>

          <form
            class="grid grid-cols-2 gap-x-4 gap-y-10 mb-10"
            autocomplete="off"
          >
            <input-text
              name="Prénom"
              class="md:col-span-1"
              libelle="Prénom"
              :value="referentToEdit.firstname"
              @input="
                (newValue) => {
                  referentToEdit.firstname = newValue;
                }
              "
              :error="true"
              :msg-error="((errors || []).firstname || [])[0]"
            />
            <input-text
              name="Nom"
              class="md:col-span-1"
              libelle="Nom"
              :value="referentToEdit.lastname"
              @input="
                (newValue) => {
                  referentToEdit.lastname = newValue;
                }
              "
              :error="true"
              :msg-error="((errors || []).lastname || [])[0]"
            />
            <input-text
              class="md:col-span-1"
              libelle="Email"
              :value="referentToEdit.newMail"
              @input="
                (newValue) => {
                  referentToEdit.newMail = newValue;
                }
              "
              :msg-error="((errors || []).newMail || [])[0]"
              :error="true"
            />
            <input-select
              name="Role"
              class="md:col-span-1"
              libelle="Role par défaut"
              :value="referentToEdit.newRole"
              @input="
                (newValue) => {
                  referentToEdit.newRole = newValue;
                }
              "
              :datas="listRoles"
              :error="true"
              :msg-error="((errors || []).newRole || [])[0]"
            />
          </form>

          <div class="flex justify-center">
            <div
              v-if="saving"
              class="w-max-content w-max"
            >
              <action-button
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                bg-color-square="bg-pink-600"
                icon-color="text-white"
                libelle="AJOUTER"
                :spinner="true"
                :right="true"
                type-shadow="shadow-pink"
              />
            </div>
            <div
              v-else
              class="w-max-content w-max"
            >
              <action-button
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                bg-color-square="bg-pink-600"
                icon-color="text-white"
                libelle="AJOUTER"
                icon="arrow-right_1"
                :right="true"
                type-shadow="shadow-pink"
                @clickAction="confirmCreateReferent()"
              />
            </div>
          </div>
        </div>

        <h5 class="my-10">
          OU
        </h5>

        <div>
          <h6 class="w-full text-center text-indigo-600 mb-10">
            Si vous souhaitez ajouter un référent existant,
            <br>
            veuillez saisir l’identifiant ou l’adresse email du référent
          </h6>
          <form
            autocomplete="off"
            @submit.prevent=""
            class="grid grid-cols-11 gap-x-4 gap-y-10 mb-10"
          >
            <input-text
              class="lg:col-span-5"
              libelle="Identifiant"
              :value="referentToEdit.username"
              @input="
                (newValue) => {
                  referentToEdit.username = newValue;
                }
              "
              :error="true"
              :msg-error="((errors || []).username || [])[0]"
            />

            <span class="col-span-1 place-self-center mt-5 text-indigo-600">OU</span>

            <input-text
              class="lg:col-span-5"
              libelle="Email"
              :value="referentToEdit.existingMail"
              @input="
                (newValue) => {
                  referentToEdit.existingMail = newValue;
                }
              "
              :error="true"
              :msg-error="((errors || []).existingMail || [])[0]"
            />

            <input-select
              name="RoleAttach"
              class="md:col-span-5"
              libelle="Role par défaut"
              :value="referentToEdit.existingRole"
              @input="
                (newValue) => {
                  referentToEdit.existingRole = newValue;
                }
              "
              :datas="listRoles"
              :error="true"
              :msg-error="((errors || []).existingRole || [])[0]"
            />
          </form>
          <div class="flex justify-center">
            <div
              v-if="saving"
              class="col-span-full justify-self-center"
            >
              <action-button
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                bg-color-square="bg-pink-600"
                icon-color="text-white"
                libelle="AJOUTER"
                :spinner="true"
                :right="true"
                type-shadow="shadow-pink"
              />
            </div>
            <div
              v-else
              class="col-span-full justify-self-center"
            >
              <action-button
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                bg-color-square="bg-pink-600"
                icon-color="text-white"
                libelle="AJOUTER"
                icon="plus-circle"
                :right="true"
                type-shadow="shadow-pink"
                @clickAction="linkReferent"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Content modal add referent -->

    <!-- BEGIN Sucess message to add a referent -->
    <div v-else-if="dataToShow == 2">
      <div class="m-5 lg:m-15 2xl:m-20">
        <h3 class="w-full text-pink-600 mb-10">
          Référent créé !
        </h3>

        <div class="mb-10">
          <p class="text-indigo-600 text-lg text-center">
            L’invitation a été transmise à {{ referentToEdit.firstname }}
            <span class="uppercase">{{ referentToEdit.lastname }}</span>, à l'adresse email {{ referentToEdit.email }}
          </p>
          <p class="text-indigo-600 text-lg text-center">
            Vous pourrez lui attribuer des carnets de parcours seulement après
            sa validation.
          </p>
        </div>

        <illustration
          name="basket"
          class="w-full"
        />
      </div>
    </div>
    <!-- END Sucess message to add a referent -->

    <!-- BEGIN Sucess message to add a referent -->
    <div v-else-if="dataToShow == 3">
      <div class="m-5 lg:m-15 2xl:m-20">
        <h3 class="w-full text-pink-600 mb-10">
          Référent rattaché !
        </h3>

        <div class="mb-10">
          <p class="text-indigo-600 text-lg text-center">
            L’invitation a été transmise à {{ referentToEdit.username }}
          </p>
          <p class="text-indigo-600 text-lg text-center">
            Vous pourrez lui attribuer des Neopass seulement après sa
            validation.
          </p>
        </div>

        <illustration
          name="basket"
          class="w-full"
        />
      </div>
    </div>
    <!-- END Sucess message to add a referent -->

    <!-- BEGIN error message to add a referent -->
    <div v-else-if="dataToShow == 100">
      <div class="m-5 lg:m-15 2xl:m-20">
        <h3 class="w-full text-pink-600 mb-10">
          Erreur lors de la création du référent !
        </h3>

        <div class="mb-10">
          <p class="text-indigo-600 text-lg text-center">
            Le référent n'a pas pu être créé.
          </p>
        </div>

        <illustration
          name="notAllowed"
          class="w-full"
        />
      </div>
    </div>
    <!-- END error message to add a referent -->
  </popup>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Popup from './../../../components/Popup';
import Icon from './../../../components/Icon';
import Illustration from './../../../components/Illustration';
import ActionButton from './../../../components/ActionButton';
import InputText from './../../../components/Inputs/InputText';
import InputSelect from './../../../components/Inputs/InputSelect';

import Constants from './../../../constants';

export default {
  name: 'CreateReferentPopup',

  props: {
    dataToShow: Number,
  },

  data() {
    return {
      constants: Constants,
    };
  },

  components: {
    Popup,
    Icon,
    Illustration,
    ActionButton,
    InputText,
    InputSelect,
  },

  computed: {
    ...mapGetters({
      saving: 'permissions/saving',
      referentToEdit: 'referents/referentToEdit',
      errors: 'permissions/errors',
      roles: 'roles/roles',
    }),

    listRoles: function () {
      let list = [];

      this.roles.forEach((role) => {
        [Constants.ROLE_TYPE_ADMIN, Constants.ROLE_TYPE_MANAGER].includes(
          role.type
        )
          ? list.push({ value: role.display_name })
          : null;
      });

      return list;
    },
  },

  methods: {
    ...mapActions({
      createReferent: 'referents/createReferent',
      attachReferent: 'referents/attachReferent',
    }),

    ...mapMutations({
      SET_ERRORS: 'permissions/SET_ERRORS',
      SET_SAVING: 'permissions/SET_SAVING',
    }),

    changeToShow(val) {
      this.$emit('showChange', val);
      this.SET_ERRORS(null);
      this.SET_SAVING(false);
    },

    confirmCreateReferent() {
      this.referentToEdit.email = this.referentToEdit.newMail;
      this.referentToEdit.role = this.referentToEdit.newRole;

      this.createReferent()
        .then((isCreated) => {
          if (isCreated) {
            this.changeToShow(2);
            return;
          }
        })
        .catch((error) => {
          this.changeToShow(100);
        });
    },

    linkReferent() {
      this.referentToEdit.email = this.referentToEdit.existingMail;
      this.referentToEdit.role = this.referentToEdit.existingRole;

      this.attachReferent()
        .then((isCreated) => {
          if (isCreated) {
            this.changeToShow(3);
            return;
          }
        })
        .catch((error) => {
          this.changeToShow(100);
        });
    },
  },
};
</script>
